var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeJuno(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
    fill: "#243443"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#EAF343"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7143 5.66667C12.7143 5.29848 12.3945 5 12 5C11.6055 5 11.2857 5.29848 11.2857 5.66667V8.05719L9.64793 6.5286C9.36899 6.26825 8.91673 6.26825 8.63778 6.5286C8.35883 6.78895 8.35883 7.21106 8.63778 7.4714L10.2756 9H7.71429C7.3198 9 7 9.29848 7 9.66667C7 10.0349 7.3198 10.3333 7.71429 10.3333H10.2756L8.63778 11.8619C8.35883 12.1223 8.35883 12.5444 8.63778 12.8047C8.91673 13.0651 9.36899 13.0651 9.64793 12.8047L11.2857 11.2761V15.6667H9.85714C9.46265 15.6667 9.14286 15.9651 9.14286 16.3333C9.14286 16.7015 9.46265 17 9.85714 17H11.2857V18.3333C11.2857 18.7015 11.6055 19 12 19C12.3945 19 12.7143 18.7015 12.7143 18.3333V17H14.1429C14.5373 17 14.8571 16.7015 14.8571 16.3333C14.8571 15.9651 14.5373 15.6667 14.1429 15.6667H12.7143V11.2761L14.3521 12.8047C14.631 13.0651 15.0833 13.0651 15.3622 12.8047C15.6412 12.5444 15.6412 12.1223 15.3622 11.8619L13.7244 10.3333H16.2857C16.6802 10.3333 17 10.0349 17 9.66667C17 9.29848 16.6802 9 16.2857 9H13.7244L15.3622 7.4714C15.6412 7.21106 15.6412 6.78895 15.3622 6.5286C15.0833 6.26825 14.631 6.26825 14.3521 6.5286L12.7143 8.05719V5.66667Z",
    fill: "#DAE43A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeJuno);
export default __webpack_public_path__ + "static/media/seJUNO.e2650a9420479743daf60a29d998b414.svg";
export { ForwardRef as ReactComponent };